import { AuctionResponse } from '@bonhams1793/bonhams-typescript'
import { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'

import { LotResponse } from '@nx/api'
import { FireModal, StyledCloseButtonContainer } from '@nx/fire/modal'

import { CostCalculator } from './CostCalculator'

interface CostCalculatorModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  auction: AuctionResponse
  lot: LotResponse
}

export function CostCalculatorModal({
  isOpen,
  setIsOpen,
  auction,
  lot,
}: CostCalculatorModalProps) {
  return (
    <StyledCostCalculatorModal isOpen={isOpen} setIsOpen={setIsOpen}>
      <CostCalculator auction={auction} lot={lot} />
    </StyledCostCalculatorModal>
  )
}

const StyledCostCalculatorModal = styled(FireModal)`
  && {
    ${({ theme }) => theme.media.up.xl} {
      min-width: 900px;
    }
  }
  ${StyledCloseButtonContainer} {
    padding-bottom: 0;
  }
`
